<template>
  <v-dialog
    v-model="dialog"
    :content-class="$vuetify.breakpoint.smAndDown
      ? 'detalhe-compra--mobile' : 'detalhe-compra--desktop'"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="320"
    persistent
  >
    <v-card
      class="grey lighten-3"
    >
      <v-app-bar
        v-if="$vuetify.breakpoint.smAndDown"
        max-height="48"
        class="px-0 gradiente-topo"
        dense
        dark
        app
        style="border-radius: 0;"
      >
        <div
          class="d-flex flex-no-wrap align-center"
          style="width: 100%;"
        >
          <v-btn
            class="ml-0 mr-3 flex-shrink-0"
            data-cy="button_fechar_modal"
            icon
            small
            @click="$router.go(-1)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title
            class="text-truncate body-2 d-block"
            data-cy="titulo_modal"
          >
            Ainda preciso de ajuda
          </v-toolbar-title>
        </div>
      </v-app-bar>

      <v-container
        tag="main"
        class="pt-12 pt-md-6"
        style="max-width:820px"
      >
        <v-btn
          v-if="$vuetify.breakpoint.mdAndUp"
          absolute
          data-cy="button_fechar_modal"
          class="mt-n5 mr-n2"
          icon
          right
          small
          top
          @click="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <TituloPagina
          :class="$vuetify.breakpoint.mdAndUp ? 'headline' : ''"
          :titulo="tituloPagina"
          class="mt-4 mt-md-2"
        />

        <ListaAindaPrecisoDeAjuda />

        <BtnVoltar
          v-if="$vuetify.breakpoint.smAndDown"
          :voltar-para="urlDetalheAssinatura"
          max-width="800px"
        />

        <v-btn
          v-else
          block
          class="mt-12"
          color="primary"
          data-cy="btn_voltar"
          outlined
          @click="$router.go(-1)"
        >
          Voltar
        </v-btn>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnVoltar from '@/components/BtnVoltar.vue';
import ListaAindaPrecisoDeAjuda from '@/components/NaoEncontrei/ListaAindaPrecisoDeAjuda.vue';
import TituloPagina from '@/components/TituloPagina.vue';

export default {
  name: 'NaoEncontrei',

  components: {
    BtnVoltar,
    ListaAindaPrecisoDeAjuda,
    TituloPagina,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      tituloPagina: 'Preciso de ajuda com a minha compra',
      footer: true,
    };
  },

};
</script>

<style lang="scss">
  .paddingBottom{
    padding-bottom: 0!important
  }

html.overflow-y-hidden {
  overflow-y: hidden !important;
}

.detalhe-compra {
  &--desktop {
    border-bottom: 12px solid #EEE;
    border-radius: 1px !important;
    border-top: 12px solid #EEE;
    height: 100vh !important;
    margin: 0 0 0 auto !important;
    max-height: 100% !important;

    .v-sheet {
      border-radius: 1px !important;
      min-height: 100%;
    }
  }
}

</style>
